import React, { useState, useEffect, useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, Button, Table, Accordion } from "react-bootstrap";
import { Store } from "react-notifications-component";
import classes from "./AllInvoiceAnalysis.module.css";
import EditSupplyModal from "../Modals/EditSupplyModal.jsx";
import ReactExport from "react-export-excel-fixed-xlsx";
import { Divider } from "rsuite";
import PermissionContext from "../../../Store/permission-context";

const AllInvoiceAnalysis = (props) => {
  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
  const PCtx = useContext(PermissionContext);
  const [AxiosError, setAxiosError] = useState("");
  const [RetrievedInvoiceRecords, setRetrievedInvoiceRecords] = useState([]);
  const [Title, setTitle] = useState("");
  const [imgDirectory, setimgDirectory] = useState(null);
  const [SentRecord, setSentRecord] = useState([]);
  const [DisplayData, setDisplayData] = useState(false);
  const [ShowModal, setShowModal] = useState(false);
  const [IsPrinting, setIsPrinting] = useState(false);

  useEffect(() => {
    let Records = props.Records;
    setRetrievedInvoiceRecords(Records);
    setDisplayData(true);

    if (props.myDates.type === "specific") {
      setTitle((" for " + props.myDates.dates).toUpperCase());
    } else {
      let thedates = [...props.myDates.dates];
      setTitle(
        (
          "from " +
          thedates[0] +
          " to " +
          thedates[thedates.length - 1] +
          "."
        ).toUpperCase()
      );
    }
  }, []);

  const PrintTheReport = () => {
    setIsPrinting(true);
    window.print();
    setIsPrinting(false);
  };

  const viewInvoice = (dir) => {
    setimgDirectory("/applauseinfotech/phpfiles/" + dir);
  };

  const cancelModal = () => {
    setShowModal(false);
  };

  const getTableCode = (ArrData, ind) => {
    let DataPresent = true;
    if (
      ArrData.ThisInvoiceRecords != undefined &&
      ArrData.ThisInvoiceRecords.length > 0
    ) {
      DataPresent = true;
    } else {
      DataPresent = false;
    }
    console.log(ArrData);
    return (
      <Row className="justify-content-around mt-3" key={ind}>
        <Col md={12} sm={11} xs={11}>
          <Accordion.Item eventKey={ind}>
            <Accordion.Header>
              {" "}
              INVOICE UPLOADED ON {ArrData.ThisDate.toUpperCase()}
            </Accordion.Header>
            <Accordion.Body>
              <Table striped bordered responsive>
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>Invoice Name</th>
                    <th>Date Uploaded</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {DataPresent &&
                    ArrData.ThisInvoiceRecords.map((tsr, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>

                        <td>{tsr.EID}</td>
                        <td>{tsr.Dates}</td>
                        <td>
                          <Button
                            variant="info"
                            className="btn-sm"
                            onClick={() => viewInvoice(tsr.Directory)}
                          >
                            View
                          </Button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>

              {!DataPresent && (
                <p style={{ color: "Red", fontSize: "15px" }}>
                  Oops! No Record for {ArrData.ThisDate}
                </p>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Col>
      </Row>
    );
  };

  const TableForPrinting = (ArrData, indx) => {
    let DataPresent = true;
    if (
      ArrData.ThisInvoiceRecords != undefined &&
      ArrData.ThisInvoiceRecords.length > 0
    ) {
      DataPresent = true;
    } else {
      DataPresent = false;
    }
    return (
      <div key={indx}>
        {props.myDates.Category === "Individual" &&
          props.myDates.Staff.toUpperCase()}
        INVOICE UPLOADED FOR {ArrData.ThisDate.toUpperCase()}
        {DataPresent &&
          ArrData.ThisInvoiceRecords.map((tsr) => (
            <div>
              <Divider style={{ fontSize: "17px", color: "black" }}>
                {"Invoice Uploaded from " + tsr.TheSupplier}
              </Divider>
              <Table
                striped
                bordered
                responsive
                key={indx}
                className={classes.table4printing}
              >
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>Invoice Name</th>
                    <th>Date Uploaded</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {tsr.TheTable.map((rec, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>

                      <td>{tsr.EID}</td>
                      <td>{tsr.Dates}</td>
                      <td>
                        <Button
                          variant="info"
                          className="btn-sm"
                          onClick={() => viewInvoice(tsr.Directory)}
                        >
                          View
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ))}
        {!DataPresent && <p>Oops! No Record for {ArrData.ThisDate}</p>}
        <hr />
      </div>
    );
  };

  return (
    <Row className={classes.margin4printing}>
      <Col md={12} sm={12} xs={12} className={classes.margin4printing}>
        <Row className={classes.margin4printing}>
          {DisplayData && (
            <Row
              className={`${
                classes.margin4printing
              } ${"justify-content-around"}`}
            >
              <Col md={5} lg={5} xs={12} sm={12}>
                <Row className="justify-content-around">
                  <Col md={12} className={classes.hide4printing}>
                    <p
                      style={{
                        fontFamily: "Times New Roman",
                        fontSize: "20px",
                        color: "brown",
                        textAlign: "center",
                      }}
                    >
                      {props.myDates.Category === "Individual" &&
                        props.myDates.Staff.toUpperCase()}{" "}
                      INVOICE(S) UPLOADED {Title}
                    </p>
                  </Col>

                  <Col
                    md={12}
                    sm={12}
                    xs={12}
                    className={classes.margin4printing}
                  >
                    <Row
                      className={`${
                        classes.margin4printing
                      } ${"justify-content-around"}`}
                    >
                      <Col
                        md={12}
                        sm={12}
                        xs={12}
                        className={classes.margin4printing}
                      >
                        <Accordion
                          defaultActiveKey={
                            props.TableToShow > -1 ? props.TableToShow : null
                          }
                        >
                          {props.myDates.type === "specific"
                            ? getTableCode(RetrievedInvoiceRecords, 0)
                            : RetrievedInvoiceRecords.map((rtrvrec, index) =>
                                getTableCode(rtrvrec, index)
                              )}
                        </Accordion>
                      </Col>
                      <Col
                        md={12}
                        sm={12}
                        xs={12}
                        className={classes.margin4printing}
                      >
                        {IsPrinting
                          ? props.myDates.type === "specific"
                            ? TableForPrinting(RetrievedInvoiceRecords, 0)
                            : RetrievedInvoiceRecords.map((rtrvrec, index) =>
                                TableForPrinting(rtrvrec, index)
                              )
                          : null}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col md={7} lg={7} xs={12} sm={12}>
                <Row className="justify-content-around pb-2">
                  <Col
                    md={12}
                    sm={12}
                    xs={12}
                    className={classes.hide4printing}
                  >
                    <img className="img-thumbnail" src={imgDirectory} />
                  </Col>
                  <hr className={`${classes.hide4printing} ${"mx-2"}`} />
                  <Col md={2} sm={6} xs={6} className={classes.hide4printing}>
                    <Button variant="info" onClick={PrintTheReport}>
                      Print
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default AllInvoiceAnalysis;
